// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition24: FC<Recognition24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M18.684 9.798a6.2 6.2 0 1 0-12.4 0 6.2 6.2 0 0 0 12.4 0ZM6.53 18.02l2.078.285 1.284 1.656 1.203-2.083a8.157 8.157 0 0 1-3.582-1.56L6.53 18.02Zm10.924-1.703a8.155 8.155 0 0 1-3.583 1.561l1.204 2.083 1.286-1.656 2.077-.286-.984-1.702Zm-.856-7.988-5.196 5.196-3.243-3.242 1.415-1.415 1.828 1.828 3.782-3.781 1.414 1.414Zm4.086 1.47a8.162 8.162 0 0 1-1.758 5.069l2.732 4.73-4.218.577-2.61 3.364-2.346-4.065-2.347 4.065-2.61-3.364-4.217-.578 2.73-4.73a8.163 8.163 0 0 1-1.756-5.069 8.2 8.2 0 0 1 16.4 0Z" />
        </svg>
    );
};

export default Recognition24;
